import { render } from "./App.vue?vue&type=template&id=13d72854"
const script = {}

import "./App.vue?vue&type=style&index=0&id=13d72854&lang=scss"

import exportComponent from "C:\\laragon\\www\\juani\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__